<div class="modal-header">
  <h4 class="modal-title"> Select Icons </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <input
      type="text"
      placeholder="Filter icons"
      [(ngModel)]="iconFilter"
      class="form-control"
    />
  </div>
  <fieldset *ngFor="let category of iconList">
    <legend>
      {{ category.name }}
    </legend>
    <div class="icons">
      <a
        href="javascript:;"
        *ngFor="let icon of category.icons | filterBy: ['name'] : iconFilter"
        [title]="icon.name"
        (click)="useIcon(icon)"
      >
        <mat-icon [title]="icon.name">{{ icon.ligature }}</mat-icon>
      </a>
    </div>
  </fieldset>
</div>
